/**
 * loading组件
 * @author zhenn
 * @time 2016-11-16
 */

import lang from '../lang';

 ;(function(win, lib) {
    const template = [
        '<div class="J_Loading">',
            '<div class="g-app-loading">',
                '<i class="icon"></i>',
                '<p class="tip">{{text}}</p>',
            '</div>',
        '</div>',
        '<style type="text/css">',
        '.J_Loading {',
            'position: fixed;',
            'background: rgba(0, 0, 0, 0.8);',
            'width: 100%;',
            'height: 100%;',
            'left: 0;',
            'top: 0;',
            'overflow: hidden;',
            'z-index: 99999;',
        '}',

        '.J_Loading .g-app-loading {',
            'width: 2.5rem;',
            'height: 2.5rem;',
            'border-radius: 0.3125rem;',
            'background: rgba(255,255,255, .9);',
            'position: absolute;',
            'left: 50%;',
            'top: 50%;',
            'margin: -1.25rem 0 0 -1.25rem;',
        '}',

        '.J_Loading .g-app-loading .icon {',
            'display: block;',
            'width: 0.9375rem;',
            'height: 0.9375rem;',
            'margin: 0.46875rem auto 0;',
            'background: url(data:image/gif;base64,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) no-repeat center center;',
            'background-size: 100% 100%;',
        '}',
        '.J_Loading .g-app-loading .tip {',
            'text-align: center;',
            'margin-top: 0.3125rem;',
            'font-size: 0.375rem;',
        '}',
        '</style>'
    ];

    lib.loading = {
        show({
            text=lang.tpl('正在加载')
        } = {}) {
    		if (this.el) {
    			return;
    		}
            let html = template.join('').replace('{{text}}' , text);

            let node = document.createElement('div');

            node.innerHTML = html;

            let el = this.el = node;

            document.body.appendChild(el);
        },

        hide() {
    		if (this.el) {
    			this.el.remove();
    			this.el = null;
    		}
        }
    };

})(window, window.Uplib || (window.Uplib = {}));



// WEBPACK FOOTER //
// ./js/component/openjs/lib/loading.js